export enum SubscriptionStatus {
    ACTIVE = 'ACTIVE',
    PENDING = 'PENDING',
    CANCELLED = 'CANCELLED',
    EXPIRED = 'EXPIRED',
}